export const LAYER_TYPE = {
    input: 0,
    hidden: 1,
    output: 2
};

export const TRAINING_STATUS = {
    waiting: 0,
    training: 1,
    finish: 2,
    canceled: 3,
    error: 4
};

export const INFERENCE_STATUS = {
    waiting: 0,
    inferencing: 1,
    success: 2,
    error: 3
};

export const AI_MODEL_TYPE = {
    neural_network: 0,
    time_series: 1
};

export const AI_MODEL_OUTPUT = {
    predict_field: 0,
    summarize_field: 1,
    exogenous_field: 2,
}

export const SUMMARIZE_PERIOD = {
    daily: 0,
    weekly: 1,
    monthly: 2,
    yearly: 3
}